// Libs
import { outlinedInputClasses } from '@mui/material';
import { Theme, Components } from '@mui/material/styles';
import { icons } from '~/assets';
// Others
import { varTypography } from '~/themes/themeVariables';

export const inputsCustomizations: Components<Theme> = {
  // Input
  MuiInputBase: {
    styleOverrides: {
      root: {
        border: 'none',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: 0,
      },
      root: ({ theme }) => ({
        padding: '15px',
        color: theme.palette.text.secondary,
        fontSize: `${theme.typography.fontSize}px`,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '6px',
        '&:hover': {
          borderColor: `${theme.palette.divider}`,
        },
        [`&.${outlinedInputClasses.focused}`]: {
          borderColor: `${theme.palette.primary.main}`,
        },
        variants: [
          {
            props: {
              size: 'small',
            },
          },
          {
            props: {
              size: 'medium',
            },
          },
        ],
      }),
      notchedOutline: {
        border: 'none',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: `${theme.palette.text.primary}`,
        fontSize: `${theme.typography.fontSize}px`,
        marginBottom: '4px',
      }),
    },
  },

  // Button
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: 'none',
        borderRadius: '8px',
        fontSize: varTypography.fontSize[14],
        padding: '8px 12px',

        '&:hover': {
          boxShadow: 'none',
        },
      }),
    },
    variants: [
      {
        props: { variant: 'contained', color: 'primary' },
        style: {
          '&:hover': {
            backgroundColor: '#2642a7',
          },
        },
      },
    ],
  },

  // Checkbox
  MuiCheckbox: {
    defaultProps: {
      icon: <img src={icons.commonIconUncheck} alt={'checkbox'} style={{ width: 16, height: 16 }} />,
      checkedIcon: <img src={icons.commonIconChecked} alt={'checkbox'} style={{ width: 16, height: 16 }} />,
      indeterminateIcon: (
        <img src={icons.commonIconIndeterminate} alt={'checkbox'} style={{ width: 16, height: 16 }} />
      ),
    },
  },

  // Dialog
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '12px',
        overflow: 'hidden',
      },
    },
  },

  MuiDialogTitle: {
    styleOverrides: {
      root: {
        borderBottom: '1px solid #E1E4EB',
        backgroundColor: '#ffffff',
        fontSize: '20px',
        fontWeight: '500',
        color: '#000000',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      },
    },
  },

  MuiDialogContent: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff',
        border: 'none',
      },
    },
  },

  MuiDialogActions: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff',
        padding: '18px 24px',
        position: 'sticky',
        bottom: 0,
        zIndex: 1000,
      },
    },
  },
};
